import { useOrganizationContextDataQuery } from './OrganizationContextDataQuery.generated';
import { sendErrorEvent } from '@trello/error-reporting';

export const useOrgContextData = (orgId: string | null) => {
  const { data, error } = useOrganizationContextDataQuery(
    orgId
      ? { variables: { orgId }, waitOn: ['None'] }
      : { skip: true, waitOn: ['None'] },
  );

  if (error)
    sendErrorEvent(error, {
      tags: { ownershipArea: 'trello-smoothie' },
    });

  return data;
};
